export default __webpack_public_path__ + "static/media/poster24.4722a9b1.png";